import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from './shared/material.module';
import { LanguageService } from './core/i18n/language.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, MaterialModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Lagesio Webapp';

  private readonly lang = inject(LanguageService);
  
  ngOnInit(): void {
    this.lang.init({
    supported: environment.supportedLangs,
    defaultLang: environment.defaultLang,
  });
  }
}
